<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5,9C5,9,7,9,7,9C7,9,7,11,7,11C7,11.6,7.4,12,8,12C8.6,12,9,11.6,9,11C9,11,9,9,9,9C9,9,11,9,11,9C11.6,9,12,8.6,12,8C12,7.4,11.6,7,11,7C11,7,9,7,9,7C9,7,9,5,9,5C9,4.4,8.6,4,8,4C7.4,4,7,4.4,7,5C7,5,7,7,7,7C7,7,5,7,5,7C4.4,7,4,7.4,4,8C4,8.6,4.4,9,5,9C5,9,5,9,5,9C5,9,5,9,5,9ZM15,0C15,0,1,0,1,0C0.4,0,0,0.4,0,1C0,1,0,15,0,15C0,15.6,0.4,16,1,16C1,16,15,16,15,16C15.6,16,16,15.6,16,15C16,15,16,1,16,1C16,0.4,15.6,0,15,0C15,0,15,0,15,0C15,0,15,0,15,0ZM14,14C14,14,2,14,2,14C2,14,2,2,2,2C2,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14C14,14,14,14,14,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Insert',
} as DefineComponent
</script>
